module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "width": "40%",
      "visible": _vm.cgpwdVisible,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.cgpwdVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "label-width": "80px",
      "rules": _vm.dataFormRules,
      "size": _vm.size,
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧的密码",
      "prop": "old_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.dataForm.old_password),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "old_password", $$v)
      },
      expression: "dataForm.old_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新的密码",
      "prop": "new_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.dataForm.new_password),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "new_password", $$v)
      },
      expression: "dataForm.new_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "confirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.dataForm.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "confirmPassword", $$v)
      },
      expression: "dataForm.confirmPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": _vm.size
    },
    nativeOn: {
      "click": function($event) {
        _vm.cgpwdVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": _vm.size,
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-4e09fd7b","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common_page/change_password.vue
// module id = tcum
// module chunks = 81